import * as React from "react"

export const Bomb=function (props) {
  //  const {width="90%",height="90%"}={props}
    return <svg  id="Layer_1" x="0px" y="0px" width={props.width} height={props.height} viewBox="0 0 512 512" enableBackground="new 0 0 512 512" >
<g>
	<path d="M218.255,131.197c16.958,0,33.379,2.285,48.987,6.542V91.448h-92.995v45.008   C188.357,133.027,203.091,131.197,218.255,131.197z"/>
    <circle fill="#020202" cx="218.255" cy="316.947" r="171.502"/>
    <path fill="none" stroke="#000000" strokeWidth="10" strokeMiterlimit="10" d="M218.255,108.849c0,0-6.776-113.407,92.398-60   c79.104,42.599,117,17,117,17"/>
    <polygon points="422.598,23.551 430.759,46.499 452.756,36.042 442.3,58.04 465.247,66.2 442.3,74.36 452.756,96.358    430.759,85.901 422.598,108.849 414.438,85.901 392.441,96.358 402.897,74.36 379.948,66.2 402.897,58.04 392.441,36.042    414.438,46.499  "/>
</g>
</svg>
}